import type { ReactNode } from "react";

type DrawerTemplateProps = {
  readonly className?: string;
  readonly content: ReactNode;
  readonly footer?: ReactNode;
  readonly header?: ReactNode;
};

export function DrawerTemplate({
  className = "",
  content,
  footer,
  header,
}: DrawerTemplateProps) {
  return (
    <section className={`flex h-full min-h-0 flex-col bg-surface ${className}`}>
      {header ? (
        <header className="flex shrink-0 items-center justify-between gap-3 border-b border-border px-5 py-4">
          {header}
        </header>
      ) : null}
      <div className="min-h-0 flex-1 overflow-y-auto px-5 py-5">{content}</div>
      {footer ? (
        <footer className="flex shrink-0 justify-end gap-2 border-t border-border bg-panel-muted px-5 py-3.5">
          {footer}
        </footer>
      ) : null}
    </section>
  );
}
